import React, { useContext, useState } from "react";
import { Context } from "../index";
import { Container, Row, Col, Image, Card, Button, Form } from "react-bootstrap";
import { observer } from "mobx-react-lite";

const Basket = observer(() => {
    const { basket } = useContext(Context);
    const [isLoading, setIsLoading] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isCompany, setIsCompany] = useState(false);

    const openPopup = () =>{
        setIsPopupOpen(true);
    }
    const closePopup = () => {
        setIsPopupOpen(false);
      };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const formData = new FormData(e.target);
        const name = formData.get('name');
        const tel = formData.get('tel');
        const email = formData.get('email');
        const inn = formData.get('inn');

        const phoneRegex = /^\+?[78][-(]?\d{3}\)?[-]?\d{3}[-]?\d{2}[-]?\d{2}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const innRegex = /^[0-9]{10,12}$/;

        // Проверка данных
        if (!name.trim()) {
            alert('Пожалуйста, введите ' + (isCompany ? 'название организации' : 'ваше имя'));
            setIsLoading(false);
            return;
        }
        
        if (isCompany && (!inn || !innRegex.test(inn))) {
            alert('Пожалуйста, введите корректный ИНН');
            setIsLoading(false);
            return;
        }

        if (!phoneRegex.test(tel)) {
            alert('Пожалуйста, введите корректный номер телефона');
            setIsLoading(false);
            return;
        }

        if (!emailRegex.test(email)) {
            alert('Пожалуйста, введите корректный адрес электронной почты');
            setIsLoading(false);
            return;
        }

        const data = {
            name,
            tel,
            email,
            ...(isCompany && { inn }), // Добавляем ИНН только для юр. лиц
            type: 'basket', // Явно указываем тип заказа
            items: basket.basketItems.map(item => ({
                name: item.name,
                quantity: item.quantity || 1,
                price: item.price,
                brand: item.brand?.name || 'Бренд не указан'
            })),
            totalPrice: basket.totalPrice,
            isCompany: isCompany
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}api/send-email`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            
            if (response.ok) {
                alert("Заявка успешно отправлена!");
                basket.clearBasket();
                closePopup();
            } else {
                alert("Произошла ошибка при отправке заявки.");
            }
        } catch (error) {
            console.error("Ошибка:", error);
            alert("Произошла ошибка при отправке заявки.");
        } finally {
            setIsLoading(false); // Сбрасываем состояние загрузки
        }
    }

    const toggleFormType = (isCompanyForm) => {
        setIsCompany(isCompanyForm);
    };

    return (
        <Container style={{ maxWidth: '800px' }}>
            <h1 className="text-left" style={{ fontSize: 30 }}>Корзина:</h1>
            {basket.basketItems.length === 0 ? (
                <div style={{ 
                    minHeight: '80vh', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center' 
                }}>
                    <h2>Корзина пуста</h2>
                </div>
            ) : (
                <Row>
                    <Col md={6}>
                        {basket.basketItems.map(item => (
                            <Card
                                key={item.id}
                                className="mb-3"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    padding: '10px',
                                    backgroundColor: '#f8f9fa',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    borderRadius: '10px',
                                    border: 'none'
                                }}
                            >
                                <Image
                                    src={process.env.REACT_APP_API_URL + 'static/' + item.img}
                                    alt={item.name || "Изображение отсутствует"}
                                    style={{ width: '100px', height: '100px', marginRight: '15px' }}
                                />
                                                                <div style={{ flex: 1 }}>
                                    <h5 style={{ fontSize:24 }}>{item.brand?.name || "Бренд не указан"}</h5>
                                    <h5>{item.name || "Название отсутствует"}</h5>
                                    <p>{item.price ? `${item.price}₽` : "Цена по запросу"}</p>
                                </div>
                                <div style={{ 
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    marginRight: '10px'
                                }}>
                                    <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        onClick={() => basket.decrementQuantity(item.id)}
                                    >
                                        -
                                    </Button>
                                    <span>{item.quantity || 1}</span>
                                    <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        onClick={() => basket.incrementQuantity(item.id)}
                                    >
                                        +
                                    </Button>
                                </div>
                                <Button
                                    variant="outline-danger"
                                    onClick={() => basket.removeBasketItem(item.id)}
                                >
                                    ✖
                                </Button>
                            </Card>
                        ))}
                    </Col>
                    <Col md={6}>
                        <Card
                            style={{
                                padding: '20px',
                                backgroundColor: '#f8f9fa',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                borderRadius: '10px',
                                border: 'none'
                            }}
                        >
                            <div className="delivery_basket">
                                <h4 style={{fontWeight: 600, fontSize: 16}}>Доставка по Екатеринбургу и обл:</h4>
                                <ul style={{paddingLeft: 10}}>
                                    <li style={{listStyle: 'inside'}}>Досталвяем заказы от 30000₽</li>
                                    <li style={{listStyle: 'inside'}}>Заказы от 50000₽ - бесплатно</li>
                                    <li style={{listStyle: 'inside'}}>По Екатеринбургу - 1500₽</li>
                                    <li style={{listStyle: 'inside'}}>Удаленные районы - 2000₽</li>
                                </ul>
                                <h4 style={{fontWeight: 600, fontSize: 16}}>Доставка по России:</h4>
                                <ul style={{paddingLeft: 10}}>
                                    <li style={{listStyle: 'inside'}}>В рабочие дни Пн-Пт</li>
                                    <li style={{listStyle: 'inside'}}>ТК Деловые Линии.</li>
                                    <li style={{listStyle: 'inside'}}>ТК Кит и др.</li>
                                </ul>
                            </div>
                            <Button
                                variant="custom"
                                className="basket_button"
                                onClick={(e) => {
                                    e.preventDefault();
                                    openPopup();
                                }
                                }
                                style={{ marginBottom: '20px', width: '100%' }}
                            >
                                Перейти к оформлению
                            </Button>
                            <h2 style={{ fontSize: 32, textAlign: 'center' }}>Итого:</h2>
                            <h3 className="text-center">{basket.totalPrice ? `${basket.totalPrice}₽` : "Цена по запросу"}</h3>
                        </Card>
                    </Col>
                </Row>

            )}
            {isPopupOpen && (
                    <div className={`pop_up ${isPopupOpen ? 'active' : ''}`}>
                      <div className="pop_up_container">
                        <div className="pop_up_body">
                          <p>Оформление заказа</p>
                          <div className="mb-3 d-flex justify-content-center gap-2">
                                <Button
                                    variant="outline-dark"
                                    onClick={() => toggleFormType(false)}
                                >
                                    Физ. лицо
                                </Button>
                                <Button
                                    variant="outline-dark"
                                    onClick={() => toggleFormType(true)}
                                >
                                    Юр. лицо
                                </Button>
                            </div>
                          <Form className="some-form" id="some-form" onSubmit={handleSubmit}>
                            {isCompany ? (
                                    <>
                                        <input 
                                            type="text" 
                                            name="name" 
                                            placeholder="Название организации" 
                                        />
                                        <input 
                                            type="text" 
                                            name="inn" 
                                            placeholder="ИНН" 
                                            pattern="[0-9]{10,12}"
                                        />
                                    </>
                                ) : (
                                    <input 
                                        type="text" 
                                        name="name" 
                                        placeholder="Ваше имя" 
                                    />
                                )}
                            <input type="tel" name="tel" placeholder="Ваш телефон" />
                            <input type="email" name="email" placeholder="Ваша почта" />
                            <div className="d-grid gap-2">
                              <Button
                                type="submit"
                                className="basket_button"
                                variant="custom"
                                size="lg"
                                disabled={isLoading}
                              >
                                {isLoading ? 'Загрузка...' : 'Отправить заявку'}
                              </Button>
                          </div>
                          </Form>
                          <div className="pop_up_close" onClick={closePopup}>✖</div>
                        </div>
                      </div>
                    </div>
                  )}
        </Container>
    );
});

export default Basket;